export default __webpack_public_path__ + "static/media/empty.2156b531.svg";